/**
 * Previously redirected all /app traffic for admins. Admins now use /app for the
 * learning dashboard and /admin for the admin dashboard; profiles stay separate.
 */
export default function AdminAppRedirect({ children }) {
  return children;
}
